import { Exclude, Transform, Type } from 'class-transformer';
import { booleanTransform } from '../utils/helper';
import { List } from './list.model';

export class Listitem {
	id!: number;
	itemlabel!: string;
	itemvalue!: string;
	sort?: number;
	lid!: number;
	@Transform(booleanTransform)
	editable?: boolean;

	@Exclude({ toPlainOnly: true })
	@Type(() => List)
	selist!: List;
}
